if (!window.__artistsCarouselInitialized) {
  window.__artistsCarouselInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    initArtistsCarousels();
    bindArtistsCarouselResize();
  });

  function shouldEnableArtistsCarousel() {
    return window.innerWidth > 991;
  }

  function initArtistsCarousels(scope = document) {
    const carousels =
      scope instanceof Element && scope.matches(".js-artists-carousel")
        ? [scope]
        : scope.querySelectorAll(".js-artists-carousel");

    carousels.forEach((element) => {
      if (!shouldEnableArtistsCarousel()) {
        destroySingleArtistsCarousel(element);
        return;
      }

      if (element.__splideInstance) return;

      const splide = new Splide(element, {
        type: "slide",
        drag: true,
        gap: "16px",
        perPage: 3,
        rewind: false,
        arrows: false,
        pagination: false,
        breakpoints: {
          1440: {
            perPage: 3,
            gap: "16px",
          },
          1298: {
            perPage: 3,
            gap: "16px",
          },
        },
      });

      splide.mount();
      element.__splideInstance = splide;
      if (typeof window.enableSplideWheelNav === "function") {
        window.enableSplideWheelNav(splide, element);
      }
    });
  }

  function destroySingleArtistsCarousel(element) {
    if (element && element.__splideInstance) {
      element.__splideInstance.destroy(true);
      element.__splideInstance = null;
    }
  }

  function destroyArtistsCarousels(scope = document) {
    const carousels =
      scope instanceof Element && scope.matches(".js-artists-carousel")
        ? [scope]
        : scope.querySelectorAll(".js-artists-carousel");

    carousels.forEach((element) => {
      destroySingleArtistsCarousel(element);
    });
  }

  function bindArtistsCarouselResize() {
    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        document.querySelectorAll(".js-artists-carousel").forEach((element) => {
          if (shouldEnableArtistsCarousel()) {
            if (!element.__splideInstance) {
              initArtistsCarousels(element);
            }
          } else {
            destroySingleArtistsCarousel(element);
          }
        });
      }, 150);
    });
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      destroyArtistsCarousels(event.target);
      initArtistsCarousels(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      destroyArtistsCarousels(event.target);
    });

    document.addEventListener("shopify:section:select", (event) => {
      destroyArtistsCarousels(event.target);
      initArtistsCarousels(event.target);
    });

    document.addEventListener("shopify:section:deselect", (event) => {
      destroyArtistsCarousels(event.target);
      initArtistsCarousels(event.target);
    });
  }
}